export enum ScrollStrategies {
  block = 'block',
  reposition = 'reposition',
  noop = 'noop',
}
